import "core-js/modules/es.array.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import store from '@/store';
export const checkAuth = value => {
  const route = window.location.href; // 获取当前url
  if (value === '' || value instanceof Array && value.length === 0) {
    return true;
  }
  //   const _value = [value].flat()
  const auth = true; // 权限判断开关，本地默认不开启
  if (auth) {
    const functionCode = store.state.user.functionCode; // 权限相关的code标识，为路由的path
    const userAuth = store.state.user.authBtns;
    // 由于路由配置跳转时，会先查询下个页面的权限；所以增加判断，当权限code和当前页面路径不匹配时，默认为true，不判断权限
    // 即zblx-index 跳=> zblx-detail，先会查询detail按钮权限，在未跳转成功还在index时，不判断权限
    if (userAuth === '*' || functionCode && !route?.includes(functionCode)) return true;
    const hasPermission = userAuth.filter(item => value === item.BtnId);
    if (hasPermission.length > 0) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
};
const auth = {
  mounted(el, binding) {
    const {
      value
    } = binding;
    const hasPermission = checkAuth(value);
    if (!hasPermission) {
      el.style.display = 'none';
    }
  }
};
export default {
  auth
};